import { render, staticRenderFns } from "./inactiveSwitcherIcon.vue?vue&type=template&id=55e0b42d&"
import script from "./inactiveSwitcherIcon.vue?vue&type=script&lang=js&"
export * from "./inactiveSwitcherIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports